import { IconButton, InputAdornment } from '@mui/material';
import React, { useRef, ChangeEvent } from 'react';
import { debounce } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { setFetchParamsAction } from './types';
import { selectFetchParams } from './selectors';

export const SearchInput = () => {
  const searchInputRef = useRef();

  const dispatch = useDispatch();
  const onChange = (search: string) => {
    dispatch(setFetchParamsAction({ search }));
  };
  const onChangeDebounced = debounce((search) => onChange(search), 600);
  const fetchParams = useSelector(selectFetchParams);

  return (
    <TextField
      type="search"
      size="small"
      placeholder="Search"
      inputRef={searchInputRef}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="clear"
              onClick={(): void => {
                if (searchInputRef.current) {
                  searchInputRef.current.value = '';
                }
                onChange('');
              }}
              size="small"
              disabled={!fetchParams.get('search')}
            >
              <ClearIcon fontSize="inherit" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      onChange={(event: ChangeEvent<HTMLInputElement>): void =>
        onChangeDebounced(event.target.value)
      }
      style={{
        width: 350,
        marginLeft: 10,
      }}
    />
  );
};
